export enum MailingStatus {
    DRAFT = 'draft',
    NOW = 'now',
    QUEUE = 'queue',
    SENT = 'sent',
}